module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-bg-beijing.7c398b80.jpg";